import React, { FC } from 'react';

import { useMatchBetsPush, useSportBetsPush, useTournamentBetsPush } from '../push/overview/hooks';
import useMarketIds from '../hooks/useMarketIds';

interface OverviewBetContext {
    sportCode: string;
    matchId?: string;
    tournamentId?: string;
}

interface OverviewBetQuery extends OverviewBetContext {
    marketId: string;
}

const OverviewBetLoader: FC<OverviewBetContext> = ({ sportCode, matchId, tournamentId }) => {
    const selectedMarketIds = useMarketIds(sportCode);
    return (
        selectedMarketIds?.map((marketId, i) => (
            <SubscribeToBets
                sportCode={sportCode}
                marketId={marketId}
                matchId={matchId}
                tournamentId={tournamentId}
                key={i}
            />
        )) || null
    );
};

const SubscribeToBets: FC<OverviewBetQuery> = ({ sportCode, marketId, tournamentId, matchId }) => {
    if (matchId) {
        return <SubscribeToMatchBets sportCode={sportCode} matchId={matchId} marketId={marketId} />;
    }
    if (tournamentId) {
        return <SubscribeToTournamentBets sportCode={sportCode} tournamentId={tournamentId} marketId={marketId} />;
    }
    return <SubscribeToAllBets sportCode={sportCode} marketId={marketId} />;
};

const SubscribeToAllBets: FC<{ sportCode: string; marketId: string }> = ({ sportCode, marketId }) => {
    useSportBetsPush(sportCode, marketId);
    return null;
};

const SubscribeToMatchBets: FC<{ sportCode: string; marketId: string; matchId: string }> = ({
    sportCode,
    marketId,
    matchId
}) => {
    useMatchBetsPush(sportCode, matchId, marketId);
    return null;
};

const SubscribeToTournamentBets: FC<{ sportCode: string; marketId: string; tournamentId: string }> = ({
    sportCode,
    marketId,
    tournamentId
}) => {
    useTournamentBetsPush(sportCode, tournamentId, marketId);
    return null;
};

export default OverviewBetLoader;
